import { render } from "./RoleCard.vue?vue&type=template&id=0d680cc6&scoped=true&ts=true"
import script from "./RoleCard.vue?vue&type=script&lang=ts"
export * from "./RoleCard.vue?vue&type=script&lang=ts"

import "./RoleCard.vue?vue&type=style&index=0&id=0d680cc6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d680cc6"]])

export default __exports__